import { InternProvider } from "../../context/InternContext";
import { useState } from "react";
import InternSidebar from "./InternSidebar";
import InternTopbar from "./InternTopbar";
import DashboardView from "./DashboardView";
import ProfileSection from "./ProfileSection";
import { Checklist, OnboardingDocs } from "./InternWidgets";
import AttendanceWidget from "./AttendanceWidget";
import LeaveSummaryWidget from "./LeaveSummaryWidget";
import CalendarSection from "./CalendarSection";
import NotificationsPanel from "./NotificationsPanel";
import ChatSection from "./ChatSection";
import CertificateSection from "./CertificateSection";
import NotesSection from "./NotesSection";
import PoliciesSection from "./PoliciesSection";
import TimelineSection from "./TimelineSection";
import HelpDeskSection from "./HelpDeskSection";
import PeopleSection from "./PeopleSection";
import '../../assets/styles/intern.css';
import { formatDateOnly } from "../../utils/helpers";
import { useInternData } from '../../context/InternContext';import "../../assets/styles/Intern/InternDashboard.css";

function InternPermissionDisplay() {
  const { initPermReqs, permBalance } = useInternData();
  return (
    <div className="card animate-in interndashboard-inline-1">
      <div className="card-header">
        <div className="card-title">Permission Requests</div>
        {permBalance && <div className="card-subtitle">{permBalance.used}h used / {permBalance.total}h total</div>}
      </div>
      <div className="card-body">
        {!initPermReqs || initPermReqs.length === 0 ?
        <div className="interndashboard-inline-2">No permission requests yet</div> :

        <div className="interndashboard-inline-3">
            {initPermReqs.map((p, i) =>
          <div key={i} className="interndashboard-inline-4">
                <div>
                  <div className="interndashboard-inline-5">{formatDateOnly(p.date)}</div>
                  <div className="interndashboard-inline-6">{p.fromTime} — {p.toTime} ({p.hours}h) · {p.reason}</div>
                </div>
                <div className="interndashboard-inline-7">
                  {p.pmStatus && <span style={{ "--interndashboard-1-background": p.pmStatus === 'approved' ? '#eff6ff' : p.pmStatus === 'rejected' ? '#fef2f2' : '#fef3c7', "--interndashboard-1-color": p.pmStatus === 'approved' ? '#1d4ed8' : p.pmStatus === 'rejected' ? '#dc2626' : '#d97706' }} className="interndashboard-dyn-1">PM: {p.pmStatus}</span>}
                  <span className={`status-badge ${p.status}`}><span className="sb-dot" />{p.status}</span>
                </div>
              </div>
          )}
          </div>
        }
      </div>
    </div>);

}

function InternPageView({ active, user, onNav }) {
  switch (active) {
    case "dashboard":return <DashboardView user={user} />;
    case "profile":return <><div className="section-label">My Profile</div><ProfileSection /></>;
    case "onboarding":return <><div className="section-label">Onboarding & Assignments</div><div className="mb-24"><OnboardingDocs /></div></>;
    case "attendance":return <><div className="section-label">Attendance</div><AttendanceWidget /></>;
    case "leave":return <><div className="section-label">Leave Summary</div><div className="interndashboard-inline-8"><LeaveSummaryWidget /><InternPermissionDisplay /></div></>;
    case "calendar":return <><div className="section-label">Calendar & Events</div><div className="interndashboard-inline-9"><CalendarSection /></div></>;
    case "announcements":return <><div className="section-label">Announcements & Notifications</div><div className="interndashboard-inline-10"><NotificationsPanel onNavigate={onNav} /></div></>;
    case "chat":return <><div className="section-label">Chat</div><ChatSection user={user} /></>;
    case "notes":return <><div className="section-label">My Notes</div><div className="interndashboard-inline-11"><NotesSection /></div></>;
    case "policies":return <><div className="section-label">Policies</div><div className="interndashboard-inline-12"><PoliciesSection /></div></>;
    case "helpdesk":return <><div className="section-label">Help Desk</div><div className="interndashboard-inline-13"><HelpDeskSection /></div></>;
    case "people":return <><div className="section-label">People Directory</div><PeopleSection /></>;
    case "certificate":return <><div className="section-label">Internship Certificate</div><div className="interndashboard-inline-14"><CertificateSection /></div></>;
    default:return <DashboardView user={user} />;
  }
}

function InternDashboardInner({ onLogout, user }) {
  const [active, setActive] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className={`app-layout ${sidebarOpen ? "sb-open" : "sb-collapsed"}`}>
      <div className="sidebar-hotzone" onMouseEnter={() => setSidebarOpen(true)} />
      <button
        type="button"
        className="sidebar-peek"
        onMouseEnter={() => setSidebarOpen(true)}
        aria-label={sidebarOpen ? "Hide menu" : "Show menu"}
      >
        {sidebarOpen ? "‹" : "›"}
      </button>
      <InternSidebar
        active={active}
        setActive={setActive}
        onLogout={onLogout}
        user={user}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      <div className="main-wrapper">
        <InternTopbar active={active} onLogout={onLogout} user={user} onNav={setActive} />
        <div className="main-content" key={active}><InternPageView active={active} user={user} onNav={setActive} /></div>
      </div>
    </div>);

}
export default function InternDashboard(props) {
  return <InternProvider><InternDashboardInner {...props} /></InternProvider>;
}

